import { ConfirmPopup, Text } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { Colors } from '~/themes/colors';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IRejectCandidateSuccessPopupProps {
  professionalName: string;
  onClose: () => void;
}

export const DeclineCandidateSuccessPopup = ({
  onClose,
  professionalName,
}: IRejectCandidateSuccessPopupProps) => (
  // @ts-expect-error - ConfirmPopup still written in JavaScript
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Interview Declined"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Text color={Colors.neutral_500}>
        <Text color={Colors.neutral_500}>{professionalName}</Text> is still an active candidate.
        Invite them
        <br />
        to future interviews from the Candidate page.
      </Text>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
